enum PciDashboardProviderTerminationTypeEnum {
  NPI = 1,
  TIN = 2
}

export { PciDashboardProviderTerminationTypeEnum };